<mat-accordion [multi]="false" class="!rounded-none">
  <mat-expansion-panel
    [ngStyle]="{ display: tipoDespacho === 2 ? 'none' : 'block' }"
    hideToggle
    style="padding: 0"
    class="!m-0 !p-0 !rounded-none mat-pn"
    [ngClass]="{
      'disabled-mat-accordion': despachos.value.informativo.length == 0
    }"
    [expanded]="
      (currentAccordion === 'informativo' || expanded == 'informativo') &&
      despachos.value.informativo.length > 0
    "
    (opened)="openClose('informativo');getEntradasByEmpresa(despacho.id_empresa)"
    (closed)="openClose('')">
    <mat-expansion-panel-header class="!m-0 !p-0 bg-lg !rounded-none">
      <mat-panel-title
        class="!flex !justify-between items-center !m-0 pl-3 pr-3 !pt-2 !pb-2">
        <span>Informativo</span>
        <span class="mat-panel-title-counter">{{ despacho.counterInfo }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-form-temas
      *ngIf="despacho.expanded"
      [temasForm]="despachos"
      [formName]="'informativo'"></app-form-temas>
  </mat-expansion-panel>
  <mat-expansion-panel
    [expanded]="
      (currentAccordion === 'vobo' || expanded == 'vobo') &&
      despachos.value.vobo.length > 0
    "
    (opened)="openClose('vobo');getEntradasByEmpresa(despacho.id_empresa)"
    (closed)="openClose('')"
    [ngStyle]="{ display: tipoDespacho === 1 ? 'none' : 'block' }"
    hideToggle
    style="padding: 0"
    class="!m-0 !p-0 !rounded-none"
    [ngClass]="{
      'disabled-mat-accordion': despachos.value.vobo.length == 0
    }">
    <mat-expansion-panel-header class="!m-0 !p-0 bg-lg !rounded-none">
      <mat-panel-title
        class="!flex !justify-between !items-center !m-0 !pl-3 !pr-3 !pt-2 !pb-2">
        <span>VoBo.</span>
        <span class="mat-panel-title-counter">{{ despacho.counterVoBo }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-form-temas
      *ngIf="despacho.expanded"
      [temasForm]="despachos"
      [formName]="'vobo'"></app-form-temas>
  </mat-expansion-panel>

  <div class="!flex !justify-end !gap-2 !p-2" style="background-color: white">
    <button mat-raised-button hideToggle>CANCELAR</button>
    <button
      [disabled]="despachos.invalid"
      (click)="save()"
      mat-flat-button
      color="primary">
      GUARDAR
    </button>
  </div>
</mat-accordion>
